import React from "react";

const Logo: React.FC<{ className?: string }> = ({ className = "h-10" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 350 80"
      className={className}
      fill="none"
    >
      {/* Icona: Fulmine energetico stilizzato */}
      <path
        d="M45 10L25 40H40L30 70L60 35H45L55 10H45Z"
        fill="url(#gradient1)"
      />
      <circle cx="60" cy="20" r="8" fill="#EC4899" opacity="0.6" />
      <circle cx="25" cy="65" r="6" fill="#F59E0B" opacity="0.7" />
      
      {/* Gradiente */}
      <defs>
        <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#6366F1" />
          <stop offset="100%" stopColor="#8B5CF6" />
        </linearGradient>
      </defs>
      
      {/* Testo */}
      <text
        x="80"
        y="35"
        fontFamily="Poppins, sans-serif"
        fontWeight="700"
        fontSize="24"
        fill="#1F2937"
      >
        Servizio Clienti
      </text>
      <text
        x="80"
        y="62"
        fontFamily="Poppins, sans-serif"
        fontWeight="600"
        fontSize="20"
        fill="url(#gradient2)"
        letterSpacing="3"
      >
        ENERGIA
      </text>
      
      {/* Gradiente per testo */}
      <defs>
        <linearGradient id="gradient2" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#6366F1" />
          <stop offset="50%" stopColor="#EC4899" />
          <stop offset="100%" stopColor="#F59E0B" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Logo;
